import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { PreferenceKeys } from 'src/app/interfaces/preference-keys.enum';

@Injectable({
  providedIn: 'root',
})
export class LanguageTranslationService {
  public selectedLanguage: BehaviorSubject<string> = new BehaviorSubject<string>(
    localStorage.getItem(PreferenceKeys.SelectedLanguage) || 'en'
  );
}
